export default {
    HELP_MENU: "Help menu",
    ASK_FOR_URGENT_HELP: "Ask for urgent help",
    DEFAULT_LOCATION: "",
    PWA: "PWA"
}